/* ADD Knowledge categories */
export const ADD_BLOCK = "ADD_BLOCK"
export const ADD_BLOCK_SUCCESS = "ADD_BLOCK_SUCCESS"
export const ADD_BLOCK_CLEAN = "ADD_BLOCK_CLEAN"
export const ADD_BLOCK_ERROR = "ADD_BLOCK_ERROR"
